import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_ON_RESET_VEHICLE_DATA = `${VEHICLE_MODULE_PREFIX}_ON_RESET_VEHICLE_DATA`;
/**
 * Action to reset all vehicle data
 * @returns IResetVehicleDataAction
 */
export const onResetVehicleDataAction = () => ({
    type: VEHICLE_ON_RESET_VEHICLE_DATA,
    payload: null
});
//# sourceMappingURL=resetVehicleDataAction.js.map